export const Gender = {
  MALE: 'M',
  FEMALE: 'F'
} as const

export type Gender = (typeof Gender)[keyof typeof Gender]

export const GenderLabel = {
  [Gender.MALE]: 'Masculino',
  [Gender.FEMALE]: 'Femenino'
} as const satisfies Record<Gender, string>
